import {Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';

@Component({
  selector: 'app-common-workflow-update-task',
  templateUrl: './common-workflow-update-task.component.html',
  styleUrls: ['../parts.css']
})
export class CommonWorkflowUpdateTaskComponent implements OnInit {

  boardData: any = {}; // 面板数据
  statusList = [
    {code: 'ACTIVE', name: '处理中'},
    {code: 'SUSPENDED', name: '暂停'},
    {code: 'COMPLETED', name: '正常结束'},
    {code: 'INTERNALLY_TERMINATED', name: '终止'},
    {code: 'EXTERNALLY_TERMINATED', name: '终止(外部)'}
  ];
  statusDisplayText = '状态';
  statusConditionVisible = false;
  statusConditionCode = '';

  isVisible = false;
  recipeId = null; // 自动化模板ID
  relationId;
  instanceData: any = {}; // 存放实例返填数据
  categorieId: string; // 存放当前目录ID
  backFillData: any;
  isConfirmLoading = false; // 确定按钮
  automation = {
    boardId: '',
    groupId: '',
    categoryId: '',
    relationId: '',
    processStatus: '',
    processCategory: 'processStatusChange',
    instanceDescription: '',
    taskMapping: {}
  }; // 存放入参数据
  @ViewChild('pulseCard', { static: true }) pulseCard: any;
  @Output() nfDataChange: EventEmitter<any> = new EventEmitter<any>();
  constructor() { }

  ngOnInit(): void {
    // 处理返填数据
    if (this.instanceData && this.instanceData.config) {
      this.automation = JSON.parse(JSON.stringify(this.instanceData.config));
      this.backFillData = this.automation.taskMapping;
      this.statusConditionCode = this.automation.processStatus;
      for (const item of this.statusList) {
        if (item.code === this.statusConditionCode) {
          this.statusDisplayText = item.name;
          break;
        }
      }
    }
    // 带入菜单ID
    this.automation.categoryId = this.categorieId;
    this.automation.relationId = this.relationId;
    this.packageData();
  }

  statusConditionChange(item) {
    this.statusConditionCode = item.code;
    this.statusDisplayText = item.name;
    this.automation.processStatus = item.code;
    this.statusConditionVisible = false;
    this.packageData();
  }

  // 弹窗创建任务
  openTaskDialog() {
    this.isVisible = true;
  }

  // 弹窗确定事件
  handleOk() {
    this.pulseCard.onSubmit();
    this.isVisible = false;
  }
  // 弹窗关闭事件
  handleCancel() {
    this.isVisible = false;
  }
  // 获取任务创建数据
  getTaskIntegrationData(event) {
    const obj: any = {};
    event.forEach((item, index) => {
      let mapObj: any;
      if (typeof item.mappingValue === 'string') {
        switch (item.type) {
          case 'dropdown':
            mapObj = {
              'fixedValue': {
                'ids': [item.mappingValue]
              }
            };
            break;
          case 'select':
            mapObj = {
              'fixedValue': {
                'option': item.mappingValue
              }
            };
            break;
          case 'button':
            mapObj = {
              'fixedValue': {
                'original': item.mappingValue
              }
            };
            break;
        }
      }
      if (item.type === 'dropdown' || item.type === 'select' || item.type === 'button') {
        obj[item.id] = mapObj;
      } else {
        const mpArr = [];
        item.mappingValue.forEach((m, i) => {
          mapObj = {
            'type': 'field',
            'sourceField': {
              'id': m.id,
              'type': m.type ? m.type : 'text',
              'title': m.title
            }
          };
          mpArr.push(mapObj);
        });
        mpArr.unshift({'type': 'text', 'text': item.mappingFirstValue});
        mpArr.push({'type': 'text', 'text': item.mappingEndValue});
        obj[item.id] = {
          'targetField': {
            'id': item.id,
            'title': item.title,
            'type': item.type,
          },
          'mappingParts': mpArr
        };
      }
      this.automation.taskMapping['mappingConfig'] = obj;
    });
    this.packageData();
  }

  // 组件提交数据
  packageData() {
    this.automation.instanceDescription = '监听到流程待办变更为 ' + this.statusDisplayText + ' 时，更新 任务 ';
    this.nfDataChange.emit(this.automation);
  }

  // 获取当前提交状态，当所有必填项都填写时返回true
  getSubmitStatus() : boolean {
    return this.statusConditionCode != '' && JSON.stringify(this.automation.taskMapping) != '{}';
  }
}
